<div class="w-100 d-flex flex-column align-items-center justify-content-start text-center">
  <p class="font-19 text-capitalize fw-bold mb-3">{{ 'widget.prelaunch_title' | translate }}</p>
  <!-- ======= counter ======= -->

 <div class="d-flex align-items-center justify-content-center w-100 gap-2 counter" >
    <div class="rounded-3 time-card text-center d-flex" [ngClass]="{ shimmer: liveCounter()._diff == 0 }">
      <div class="value">{{ liveCounter()._days }}</div>
      <div class="indicator">{{ 'widget.days' | translate }}</div>
    </div>
    <div class="rounded-3 time-card text-center" [ngClass]="{ shimmer: liveCounter()._diff == 0 }">
      <div class="value">{{ liveCounter()._hours }}</div>
      <div class="indicator">{{ 'widget.hours' | translate }}</div>
    </div>
    <div class="rounded-3 time-card text-center" [ngClass]="{ shimmer: liveCounter()._diff == 0 }">
      <div class="value">{{ liveCounter()._minutes }}</div>
      <div class="indicator">{{ 'widget.minutes' | translate }}</div>
    </div>
    <div class="rounded-3 time-card text-center" [ngClass]="{ shimmer: liveCounter()._diff == 0 }">
      <div class="value">{{ liveCounter()._seconds }}</div>
      <div class="indicator">{{ 'widget.seconds' | translate }}</div>
    </div>
  </div>

  <p class="font-19 text-capitalize fw-bold mt-4 mb-3">{{ 'widget.prelaunch_title_updates' | translate }}</p>
  <div class="d-flex align-items-center justify-content-center w-100 gap-3">
  <a href="https://t.me/predexofficial" target="_blank"><img src="/assets/images/svg-icons/social-icons/telegram.svg" alt="telegram-icon"></a>
  <a href="https://x.com/predexxyz" target="_blank"><img src="/assets/images/svg-icons/social-icons/x.svg" alt="x-icon"></a>
  <a href="https://www.instagram.com/predex.xyz/" target="_blank"><img src="/assets/images/svg-icons/social-icons/instagram.svg" alt="instagram-icon"></a>
  </div> 
</div>
